import { render } from "./Navigation.vue?vue&type=template&id=bcc70a34&ts=true&lang=pug"
import script from "./Navigation.vue?vue&type=script&lang=ts"
export * from "./Navigation.vue?vue&type=script&lang=ts"

import "./Navigation.vue?vue&type=style&index=0&id=bcc70a34&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__